import { service } from '@ember/service';
import Component from '@glimmer/component';

import { trackedFunction } from 'reactiveweb/function';

import ContentItems from 'umg-ember-backend/components/page-builder/content-items';

export default class PageBuilderContentItemsItemForMlpRow extends Component {
  // Services
  @service media;
  @service pageBuilderFrontendApi;

  // Getter and setter
  get allowToAddColumn() {
    return this.args.contentItem.children.length < 4;
  }

  get rowConfig() {
    return this.themeConfig?.cms?.['mlp-row'];
  }

  get themeConfig() {
    return this.loadThemeConfig.value;
  }

  // Functions
  loadThemeConfig = trackedFunction(this, async () => {
    return await this.pageBuilderFrontendApi.loadThemeConfig(
      this.pageBuilderFrontendApi.host,
      this.args.mlp,
    );
  });

  // Template
  <template>
    <ContentItems
      @contentItems={{@contentItem.children}}
      @contentItemTypeOptions={{this.rowConfig.contentItems}}
      @direction={{if this.media.isDesktop 'x' 'y'}}
      @isDisabled={{@isDisabled}}
      @isSelectAllowed={{this.allowToAddColumn}}
      @mlp={{@mlp}}
      @onSelectContentItem={{@onSelectContentItem}}
      @onSaveMlp={{@onSaveMlp}}
      @parent={{@contentItem}}
      @selectedContentItem={{@selectedContentItem}}
    />
  </template>
}
